import defaultPalette from '../palette';
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiToggleButton: {
            root: {
                color: palette.grey[600],
                border: "1px solid " + palette.grey[400],
                '&$disabled': {
                    color: palette.grey[400],
                    backgroundColor: palette.common.white,
                },
                '&.Mui-selected': {
                    color: palette.grey[900],
                    backgroundColor: palette.action.selected,
                },
                '&.Mui-selected.Mui-disabled': {
                    color: palette.grey[400],
                    backgroundColor: palette.common.white,
                },
            },
        },
    };
});
